/**
 * @generated SignedSource<<b729a3a633e3fefcca43cf0a5067ab7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type indexOld_developmentSummaryVulnerability_VulnerabilityDropdown$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"indexOld_developmentSummaryVulnerability_VulnerabilityDropdownItem">;
  readonly " $fragmentType": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdown";
}>;
export type indexOld_developmentSummaryVulnerability_VulnerabilityDropdown$key = ReadonlyArray<{
  readonly " $data"?: indexOld_developmentSummaryVulnerability_VulnerabilityDropdown$data;
  readonly " $fragmentSpreads": FragmentRefs<"indexOld_developmentSummaryVulnerability_VulnerabilityDropdown">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdown",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdownItem"
    }
  ],
  "type": "DevOpsSecurityVulnerabilityDetails"
};

(node as any).hash = "66ecf515592ef71d24709cf99c64c80e";

export default node;
